export const TRACK_LENGTH = 25600;

// How far the difficulty ramp takes to reach full, independent of how long the
// hill is. Normalising over TRACK_LENGTH instead -- which is what this used to
// do -- means a longer course does not get harder, it stretches the same curve
// over more ground: the sparse early segments stay dominant twice as long and
// the tightest pinches still only arrive at the very end. Pinning the ramp to a
// fixed distance means a longer hill is a longer hard section.
export const RAMP_DISTANCE = 12000;
export const COURSE_WIDTH = 460;
export const START_PAD = 880;
export const FINISH_CLEAR = 420;
export const BANK = 110;

export const PLAYER_RADIUS = 16;
export const PLAYER_DRAW = 54;

export const MIN_SPEED = 170;
export const CRUISE_SPEED = 305;
export const MAX_SPEED = 980;
export const GROUND_ACCEL = 95;
export const GROUND_DRAG = 32;
export const AIR_ACCEL = 215;
export const STEER_BASE = 340;
export const STEER_SPEED_GAIN = 0.14;

// The tuck: held, grounded and unstunned, it accelerates the tube toward its
// own cap instead of settling at cruise -- and holds a ramp landing there
// instead of letting drag bleed it away. The cap sits deliberately inside the
// clamp: ramps and airtime stay the only road to MAX_SPEED, so the
// leaderboard's anti-cheat floor (TRACK_LENGTH / MAX_SPEED) and the course
// generator's reachability proof, both derived from the clamp, are untouched.
export const TUCK_ACCEL = 240;
export const TUCK_MAX = 620;

export const STUN_TIME = 0.55;
export const KNOCKBACK = 128;
export const HIT_SPEED_KEEP = 0.38;

export const JUMP_VEL = 248;
export const JUMP_SPEED_BONUS = 0.085;
export const AIR_GRAVITY = 540;
export const AIR_PASS_HEIGHT = 14;

export const FIXED_DT = 1 / 60;
export const MAX_FRAME_DT = 0.1;
export const SUBSTEP_PX = 12;

export const PLAYER_SCREEN_MIN = 0.2;
export const PLAYER_SCREEN_MAX = 0.34;
export const MIN_LOOKAHEAD = 620;

// A near-miss: passing a solid this close, this fast, earns the whoosh. The
// band starts just outside the crash radius and spans about a tube's width.
export const GRAZE_BAND = 30;
export const GRAZE_MIN_SPEED = 420;

// Bumped when the best changed currency from raw seconds to adjusted ms. An
// old value under the previous key would read as an absurdly good time.
export const BEST_KEY = "sharp-mountain-best-v2";
export const MUTED_KEY = "sharp-mountain-muted-v1";
export const MUSIC_KEY = "sharp-mountain-music-v1";
// Set once the one-time tuck hint has been shown -- or the moment the player
// tucks unprompted, which proves they never needed it.
export const TUCK_HINT_KEY = "sharp-mountain-tuck-hint-v1";

export const SNOW_TILE = 256;
